import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { whoAmI } from 'utils/api';
import { User } from 'utils/types';
import { isUserValid, getUserInvalidErrorMessage } from 'utils/validation';
import LoadingSpinner from '../Loading/LoadingSpinner';
import ErrorDialog from '../ErrorDialog/ErrorDialog';
import SmartLogs from './SmartLogs';


function Home() {
    const navigate = useNavigate();
  
    const [user, setUser] = useState<User | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const clearError = () => {
        setErrorMessage(null);
        navigate('/login');
    };

    useEffect(() => {
        if (localStorage.getItem('token')) {
            whoAmI()
                .then((data: User) => {
                    if (isUserValid(data)) {
                      setUser(data);
                    }
                    else {
                        setErrorMessage(getUserInvalidErrorMessage(data));
                    }
                })
                .catch(() => {
                    setErrorMessage(
                        [
                            "Network problem to validate the user.",
                            "Try again later.",
                            "If the problem persists, contact the admin.",
                        ].join(" ")
                    )
                });
        }
        else {
            navigate('/login');
        }
    }, [navigate]);

    let component;

    if(user === null) {
        if(errorMessage === null) {
            component = <LoadingSpinner />;
        }
        else {
            component = <ErrorDialog message={errorMessage} onErrorDisplay={clearError} />;
        }
    }
    else {
        component = <SmartLogs user={user} />;
    }

    return component;
}

export default Home;
